import { render, staticRenderFns } from "./NTApplyComPopup.vue?vue&type=template&id=4980db8f&scoped=true"
import script from "./NTApplyComPopup.vue?vue&type=script&lang=js"
export * from "./NTApplyComPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980db8f",
  null
  
)

export default component.exports